module.exports = __webpack_public_path__ + "img/Document-Finish-Popup-th.f1b7ae6.png";